/* tslint:disable */
// !!!! contains come fixes !!!
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v11.20.1.0 (NJsonSchema v9.11.0.0 (Newtonsoft.Json v9.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { ApiException } from "./common/ApiException";

export class AuthorityService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl ? baseUrl : "";
  }

  getAuthorityType(): Promise<void> {
    let url_ = this.baseUrl + "/oauth/token";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "OPTIONS",
      headers: {}
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAuthorityType(_response);
    });
  }

  protected processGetAuthorityType(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then(_responseText => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  requestToken(
    tokenRequest: { [key: string]: string } | null | undefined,
    authorization: string | null | undefined,
    user_Agent: string | null | undefined
  ): Promise<SlidingAccessToken | null> {
    let url_ = this.baseUrl + "/oauth/token";
    url_ = url_.replace(/[?&]$/, "");

    var formUrlEncoded: string = "";
    if (tokenRequest !== null && tokenRequest !== undefined) {
      var formBody = [];
      for (var property in tokenRequest) {
        var encodedKey = encodeURIComponent(property);
        var encodedValue = encodeURIComponent(tokenRequest[property]);
        formBody.push(encodedKey + "=" + encodedValue);
        formUrlEncoded = formBody.join("&");
      }
    }

    let options_ = <RequestInit>{
      body: formUrlEncoded,
      method: "POST",
      headers: {
        Authorization: authorization !== undefined && authorization !== null ? "" + authorization : "",
        "User-Agent": user_Agent !== undefined && user_Agent !== null ? "" + user_Agent : "",
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        Accept: "application/json"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processRequestToken(_response);
    });
  }

  protected processRequestToken(response: Response): Promise<SlidingAccessToken | null> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 ? SlidingAccessToken.fromJS(resultData200) : <any>null;
        return result200;
      });
    } else if (status === 400) {
      return response.text().then(_responseText => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = resultData400 ? ErrorInfo.fromJS(resultData400) : <any>null;
        return throwException("A server error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then(_responseText => {
        return throwException("A server error occurred.", status, _responseText, _headers);
      });
    } else if (status === 401) {
      return response.text().then(_responseText => {
        return throwException("A server error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<SlidingAccessToken | null>(<any>null);
  }
}

export class UserService {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl ? baseUrl : "";
  }

  /**
   * Gets user's information.
   */
  get(): Promise<User | null> {
    let url_ = this.baseUrl + "/api/v1/user";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGet(_response);
    });
  }

  protected processGet(response: Response): Promise<User | null> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 ? User.fromJS(resultData200) : <any>null;
        return result200;
      });
    } else if (status === 404) {
      return response.text().then(_responseText => {
        return throwException("A server error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<User | null>(<any>null);
  }

  /**
   * Gets user's passphrase.
   */
  getPassphrase(): Promise<string | null> {
    let url_ = this.baseUrl + "/api/v1/user/passphrase";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetPassphrase(_response);
    });
  }

  protected processGetPassphrase(response: Response): Promise<string | null> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;
        return result200;
      });
    } else if (status === 404) {
      return response.text().then(_responseText => {
        return throwException("A server error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<string | null>(<any>null);
  }

  /**
   * Sets user's passphrase.
   * @param passphrase Passphrase to be set.
   */
  createPassphrase(passphrase: string | null): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/user/passphrase?";
    if (passphrase === undefined) throw new Error("The parameter 'passphrase' must be defined.");
    else url_ += "passphrase=" + encodeURIComponent("" + passphrase) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "POST",
      headers: {}
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreatePassphrase(_response);
    });
  }

  protected processCreatePassphrase(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 201) {
      return response.text().then(_responseText => {
        return;
      });
    } else if (status === 400) {
      return response.text().then(_responseText => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = resultData400 ? ModelStateDictionary.fromJS(resultData400) : <any>null;
        return throwException("A server error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * Delete user's passphrase.
   */
  deletePassphrase(): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/user/passphrase";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "DELETE",
      headers: {}
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDeletePassphrase(_response);
    });
  }

  protected processDeletePassphrase(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then(_responseText => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * Resets user password.
   * @param login User login name.
   */
  resetPassword(login: string | null): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/user/password/reset?";
    if (login === undefined) throw new Error("The parameter 'login' must be defined.");
    else url_ += "login=" + encodeURIComponent("" + login) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "PATCH",
      headers: {}
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processResetPassword(_response);
    });
  }

  protected processResetPassword(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then(_responseText => {
        return;
      });
    } else if (status === 404) {
      return response.text().then(_responseText => {
        return throwException("A server error occurred.", status, _responseText, _headers);
      });
    } else if (status === 403) {
      return response.text().then(_responseText => {
        return throwException("A server error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }
}

export class SlidingAccessToken implements ISlidingAccessToken {
  access_token?: string | undefined;
  refresh_token?: string | undefined;
  token_type?: string | undefined;

  constructor(data?: ISlidingAccessToken) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.access_token = data["access_token"];
      this.refresh_token = data["refresh_token"];
      this.token_type = data["token_type"];
    }
  }

  static fromJS(data: any): SlidingAccessToken {
    data = typeof data === "object" ? data : {};
    let result = new SlidingAccessToken();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["access_token"] = this.access_token;
    data["refresh_token"] = this.refresh_token;
    data["token_type"] = this.token_type;
    return data;
  }
}

export interface ISlidingAccessToken {
  access_token?: string | undefined;
  refresh_token?: string | undefined;
  token_type?: string | undefined;
}

export class ErrorInfo implements IErrorInfo {
  error?: string | undefined;
  error_description?: string | undefined;

  constructor(data?: IErrorInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.error = data["error"];
      this.error_description = data["error_description"];
    }
  }

  static fromJS(data: any): ErrorInfo {
    data = typeof data === "object" ? data : {};
    let result = new ErrorInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["error"] = this.error;
    data["error_description"] = this.error_description;
    return data;
  }
}

export interface IErrorInfo {
  error?: string | undefined;
  error_description?: string | undefined;
}

export class ModelStateDictionary implements IModelStateDictionary {
  root?: ModelStateEntry | undefined;
  maxAllowedErrors!: number;
  hasReachedMaxErrors!: boolean;
  errorCount!: number;
  count!: number;
  keys!: string[];
  values!: ModelStateEntry[];
  isValid!: boolean;
  validationState!: ModelValidationState;
  item?: ModelStateEntry | undefined;

  constructor(data?: IModelStateDictionary) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.keys = [];
      this.values = [];
    }
  }

  init(data?: any) {
    if (data) {
      this.root = data["Root"] ? ModelStateEntry.fromJS(data["Root"]) : <any>undefined;
      this.maxAllowedErrors = data["MaxAllowedErrors"];
      this.hasReachedMaxErrors = data["HasReachedMaxErrors"];
      this.errorCount = data["ErrorCount"];
      this.count = data["Count"];
      if (data["Keys"] && data["Keys"].constructor === Array) {
        this.keys = [];
        for (let item of data["Keys"]) this.keys.push(item);
      }
      if (data["Values"] && data["Values"].constructor === Array) {
        this.values = [];
        for (let item of data["Values"]) this.values.push(ModelStateEntry.fromJS(item));
      }
      this.isValid = data["IsValid"];
      this.validationState = data["ValidationState"];
      this.item = data["Item"] ? ModelStateEntry.fromJS(data["Item"]) : <any>undefined;
    }
  }

  static fromJS(data: any): ModelStateDictionary {
    data = typeof data === "object" ? data : {};
    let result = new ModelStateDictionary();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["Root"] = this.root ? this.root.toJSON() : <any>undefined;
    data["MaxAllowedErrors"] = this.maxAllowedErrors;
    data["HasReachedMaxErrors"] = this.hasReachedMaxErrors;
    data["ErrorCount"] = this.errorCount;
    data["Count"] = this.count;
    if (this.keys && this.keys.constructor === Array) {
      data["Keys"] = [];
      for (let item of this.keys) data["Keys"].push(item);
    }
    if (this.values && this.values.constructor === Array) {
      data["Values"] = [];
      for (let item of this.values) data["Values"].push(item.toJSON());
    }
    data["IsValid"] = this.isValid;
    data["ValidationState"] = this.validationState;
    data["Item"] = this.item ? this.item.toJSON() : <any>undefined;
    return data;
  }
}

export interface IModelStateDictionary {
  root?: ModelStateEntry | undefined;
  maxAllowedErrors: number;
  hasReachedMaxErrors: boolean;
  errorCount: number;
  count: number;
  keys: string[];
  values: ModelStateEntry[];
  isValid: boolean;
  validationState: ModelValidationState;
  item?: ModelStateEntry | undefined;
}

export abstract class ModelStateEntry implements IModelStateEntry {
  rawValue?: any | undefined;
  attemptedValue?: string | undefined;
  errors?: any | undefined;
  validationState!: ModelValidationState;

  constructor(data?: IModelStateEntry) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.rawValue = data["RawValue"];
      this.attemptedValue = data["AttemptedValue"];
      this.errors = data["Errors"];
      this.validationState = data["ValidationState"];
    }
  }

  static fromJS(data: any): ModelStateEntry {
    data = typeof data === "object" ? data : {};
    throw new Error("The abstract class 'ModelStateEntry' cannot be instantiated.");
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["RawValue"] = this.rawValue;
    data["AttemptedValue"] = this.attemptedValue;
    data["Errors"] = this.errors;
    data["ValidationState"] = this.validationState;
    return data;
  }
}

export interface IModelStateEntry {
  rawValue?: any | undefined;
  attemptedValue?: string | undefined;
  errors?: any | undefined;
  validationState: ModelValidationState;
}

export class ModelError implements IModelError {
  exception?: Exception | undefined;
  errorMessage?: string | undefined;

  constructor(data?: IModelError) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.exception = data["Exception"] ? Exception.fromJS(data["Exception"]) : <any>undefined;
      this.errorMessage = data["ErrorMessage"];
    }
  }

  static fromJS(data: any): ModelError {
    data = typeof data === "object" ? data : {};
    let result = new ModelError();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["Exception"] = this.exception ? this.exception.toJSON() : <any>undefined;
    data["ErrorMessage"] = this.errorMessage;
    return data;
  }
}

export interface IModelError {
  exception?: Exception | undefined;
  errorMessage?: string | undefined;
}

export class Exception implements IException {
  message?: string | undefined;
  innerException?: Exception | undefined;
  stackTrace?: string | undefined;
  source?: string | undefined;

  constructor(data?: IException) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.message = data["Message"];
      this.innerException = data["InnerException"] ? Exception.fromJS(data["InnerException"]) : <any>undefined;
      this.stackTrace = data["StackTrace"];
      this.source = data["Source"];
    }
  }

  static fromJS(data: any): Exception {
    data = typeof data === "object" ? data : {};
    let result = new Exception();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["Message"] = this.message;
    data["InnerException"] = this.innerException ? this.innerException.toJSON() : <any>undefined;
    data["StackTrace"] = this.stackTrace;
    data["Source"] = this.source;
    return data;
  }
}

export interface IException {
  message?: string | undefined;
  innerException?: Exception | undefined;
  stackTrace?: string | undefined;
  source?: string | undefined;
}

export enum ModelValidationState {
  Unvalidated = "Unvalidated",
  Invalid = "Invalid",
  Valid = "Valid",
  Skipped = "Skipped"
}

export class User implements IUser {
  id!: string;
  name!: string;
  email!: string;
  enabled!: boolean;
  organization?: string | undefined;
  storageLimit!: number;
  otpOption?: string | undefined;
  otpEnabled!: boolean;
  otpContact?: string | undefined;
  otpAlternateContact?: string | undefined;
  localeCode?: string | undefined;
  role!: IdentityRoles;
  authorityType!: AuthorityType;
  assistants?: string | undefined;
  activated!: boolean;

  constructor(data?: IUser) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data["Id"];
      this.name = data["Name"];
      this.email = data["Email"];
      this.enabled = data["Enabled"];
      this.organization = data["Organization"];
      this.storageLimit = data["StorageLimit"];
      this.otpOption = data["OtpOption"];
      this.otpEnabled = data["OtpEnabled"];
      this.otpContact = data["OtpContact"];
      this.otpAlternateContact = data["OtpAlternateContact"];
      this.localeCode = data["LocaleCode"];
      this.role = data["Role"];
      this.authorityType = data["AuthorityType"];
      this.assistants = data["Assistants"];
      this.activated = data["Activated"];
    }
  }

  static fromJS(data: any): User {
    data = typeof data === "object" ? data : {};
    let result = new User();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["Id"] = this.id;
    data["Name"] = this.name;
    data["Email"] = this.email;
    data["Enabled"] = this.enabled;
    data["Organization"] = this.organization;
    data["StorageLimit"] = this.storageLimit;
    data["OtpOption"] = this.otpOption;
    data["OtpEnabled"] = this.otpEnabled;
    data["OtpContact"] = this.otpContact;
    data["OtpAlternateContact"] = this.otpAlternateContact;
    data["LocaleCode"] = this.localeCode;
    data["Role"] = this.role;
    data["AuthorityType"] = this.authorityType;
    data["Assistants"] = this.assistants;
    data["Activated"] = this.activated;
    return data;
  }
}

export interface IUser {
  id: string;
  name: string;
  email: string;
  enabled: boolean;
  organization?: string | undefined;
  storageLimit: number;
  otpOption?: string | undefined;
  otpEnabled: boolean;
  otpContact?: string | undefined;
  otpAlternateContact?: string | undefined;
  localeCode?: string | undefined;
  role: IdentityRoles;
  authorityType: AuthorityType;
  assistants?: string | undefined;
  activated: boolean;
}

export enum IdentityRoles {
  Admin = "Admin",
  Agent = "Agent",
  Internal = "Internal",
  Regular = "Regular",
  Service = "Service"
}

export enum AuthorityType {
  Cgm = "Cgm",
  Pba = "Pba",
  UserCore = "UserCore"
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): any {
  if (result !== null && result !== undefined) throw result;
  else throw new ApiException(message, status, response, headers, null);
}



// WEBPACK FOOTER //
// ./src/services/authority.service.ts